<!-- @veltra/icons generated sha256:57ecc5816a32b162 gen:8 source:src/svg/normal/form-cascader.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormCascader' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <rect
      width="6"
      height="12"
      x="1"
      y="2"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      rx="1.5"
    />
    <rect
      width="6"
      height="12"
      x="9"
      y="2"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      rx="1.5"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.2"
      d="m4 7.5 1 1-1 1"
    />
  </svg>
</template>
